import { analytics } from '@istyle-inc/analytics-component';

const setDefault = (binding) => {
  if (binding && typeof binding.value === 'object') {
    binding.value.category = binding.value.category || 'global_navigation';
  }
  return binding;
};

export default {
  inserted(el, binding) {
    return analytics.inserted(el, setDefault(binding));
  },

  bind(el, binding) {
    return analytics.bind(el, setDefault(binding));
  },

  update(el, binding) {
    return analytics.update(el, setDefault(binding));
  },

  unbind: analytics.unbind,
};
